import type { SortOrder } from 'antd/lib/table/interface';
import type { ColumnsType } from 'antd/lib/table';
import type { MetersByMeterModelsFilter, PopulatedCombinedMeter } from 'lib/services';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { MeterReviewButton } from '../components/MeterReviewButton';
import { Icon } from '@/components/icon';
import { Flex } from 'antd';
import { TRANSLATED_COMMODITY } from '@/utils/commodities';

const getSortOrder = (filter: MetersByMeterModelsFilter, columnKey: keyof PopulatedCombinedMeter): SortOrder => {
  const [sortField, sortOrder = null] = (filter.sort ?? '').split(':');
  return sortField === columnKey ? (sortOrder as SortOrder) : null;
};

export const getTableColumns = (filter: MetersByMeterModelsFilter): ColumnsType<PopulatedCombinedMeter> => [
  {
    width: 70,
    key: 'toolsId' satisfies keyof PopulatedCombinedMeter,
    sorter: true,
    sortOrder: getSortOrder(filter, 'toolsId'),
    title: 'Tools ID',
    render: (_, { toolsId }) => <Link to={`/portfolio/meters/${toolsId}`}>{toolsId}</Link>,
  },
  {
    width: 400,
    key: 'name' satisfies keyof PopulatedCombinedMeter,
    sorter: true,
    sortOrder: getSortOrder(filter, 'name'),
    title: 'Name',
    render: (_, { toolsId, name }) => <Link to={`/portfolio/meters/${toolsId}`}>{name}</Link>,
  },
  {
    width: 100,
    key: 'commodity' satisfies keyof PopulatedCombinedMeter,
    sorter: true,
    sortOrder: getSortOrder(filter, 'commodity'),
    title: 'Commodity',
    render: (_, { commodity }) => <span>{TRANSLATED_COMMODITY[commodity]}</span>,
  },
  {
    key: 'submitted_at' satisfies keyof PopulatedCombinedMeter,
    width: 100,
    sorter: true,
    sortOrder: getSortOrder(filter, 'submitted_at'),
    render: (_, { submitted_at }) => <span>{submitted_at ? dayjs(submitted_at).format('D.M.YYYY H:mm') : '-'}</span>,
    title: 'Submitted At',
  },
  {
    key: 'origin' satisfies keyof PopulatedCombinedMeter,
    width: 100,
    title: 'Origin',
    sorter: true,
    sortOrder: getSortOrder(filter, 'origin'),
    render: (_, { origin }) => <span>{origin ?? '-'}</span>,
  },
  {
    width: 80,
    key: 'reviewed',
    align: 'center' as const,
    title: 'Reviewed',
    render: (_, { reviewed_at }) => (reviewed_at ? <Icon iconString="check" /> : null),
  },
  {
    key: 'reviewed_by' satisfies keyof PopulatedCombinedMeter,
    width: 100,
    sorter: true,
    sortOrder: getSortOrder(filter, 'reviewed_by'),
    title: 'Reviewed By',
    render: (_, { reviewed_by }) => <span>{reviewed_by ?? '-'}</span>,
  },
  {
    key: 'reviewed_at' satisfies keyof PopulatedCombinedMeter,
    width: 100,
    sorter: true,
    sortOrder: getSortOrder(filter, 'reviewed_at'),
    title: 'Reviewed At',
    render: (_, { reviewed_at }) => <span>{reviewed_at ? dayjs(reviewed_at).format('D.M.YYYY H:mm') : '-'}</span>,
  },
  {
    fixed: 'right' as const,
    key: 'action',
    align: 'right' as const,
    width: 100,
    title: 'Action',

    render: (_, combinedMeter) => (
      <Flex align="center" justify="end">
        <MeterReviewButton meter={combinedMeter} />
      </Flex>
    ),
  },
];
